import { UPDATE_PENDING_STOCK_REQUESTS_COUNT } from '../actions/stockRequestActions';

const initialState = {
    pendingStockRequests: 0
};

const stockRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PENDING_STOCK_REQUESTS_COUNT:
            return {
                ...state,
                pendingStockRequests: action.payload
            };
        default:
            return state;
    }
};

export default stockRequestReducer;